import { isSameYear, isValid } from 'date-fns';

import { formatDatetime } from '../formatDatetime/formatDatetime';

type Format =
  // 23. september - 24. september 2020
  // 23. september 2019 - 9. januar 2020
  | 'default'

  // 23.09.2019 - 24.09.2019
  | 'short';

export function formatDateInterval(startDate: string, endDate: string, format?: Format): string;
export function formatDateInterval(startDate: Date, endDate: Date, format?: Format): string;
export function formatDateInterval(
  startDate: Date | string,
  endDate: Date | string,
  format = 'default'
): string {
  const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

  if (!isValid(start) || !isValid(end)) {
    return '';
  }

  const formattedStart = formatDatetime(
    start,
    format === 'short' ? 'dateWithYearShort' : isSameYear(start, end) ? 'date' : 'dateWithYear'
  );
  const formattedEnd = formatDatetime(
    end,
    format === 'short' ? 'dateWithYearShort' : 'dateWithYear'
  );

  return `${formattedStart} - ${formattedEnd}`;
}
